import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { addResizeEndListener, removeResizeEndListener } from '@/utils';

import { Container } from './ContainerDimensions.styles';

const getDimensions = (target) => {
  if (typeof target === 'string') {
    return document.getElementById(target).getBoundingClientRect();
  }

  return target.getBoundingClientRect();
};

function ContainerDimensions({ children }) {
  const wrapperRef = useRef(null);

  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
    screenWidth: 0,
    screenHeight: 0,
  });

  const onResize = () => {
    if (!wrapperRef.current) return;

    const { width, height } = getDimensions(wrapperRef.current);
    const { clientWidth: screenWidth, clientHeight: screenHeight } =
      document.documentElement;

    setDimensions({
      width,
      height,
      screenWidth,
      screenHeight,
    });
  };

  useEffect(() => {
    onResize(); // initialize

    const listener = addResizeEndListener(wrapperRef.current, onResize);

    return () => {
      if (wrapperRef.current) {
        removeResizeEndListener(wrapperRef.current, listener);
      }
    };
  }, []);

  return <Container ref={wrapperRef}>{children(dimensions)}</Container>;
}

ContainerDimensions.propTypes = {
  children: PropTypes.func.isRequired,
};

export default ContainerDimensions;
